export default "<textarea id=\"{{elementId}}\">{{value}}</textarea>\n<!--[(ngModel)]=\"value\"-->\n";